import {
  getProxy,
  type Component,
  type ControlProxy,
  type ShowFormParameters,
} from "@/global";
import { inject, watch } from "vue";

export function useFormModel() {
  const formModel = inject<Record<string, any>>("formModel");
  const cmp = inject<Component>("component")!;
  const proxy = inject<ControlProxy>("proxy")!;
  const enabled = formModel && cmp && Object.keys(formModel).includes(cmp.key);

  watch(
    () => proxy.props.modelValue,
    (value: any) => setFormModel(value),
    { immediate: true }
  );

  function setFormModel(value: any) {
    if (!enabled) return;
    formModel[cmp.key] = value;
  }

  return { setFormModel };
}

export function useFormValidate(formKeys: string[]) {
  const showParams = inject<ShowFormParameters>("showParams")!;
  function create() {
    return async () => {
      let isOK = true;
      for (let index = 0; index < formKeys.length; index++) {
        const formKey = formKeys[index]!;
        const proxy = getProxy(showParams.pageId, formKey) as ControlProxy;
        if (!proxy) continue;
        const valid = await proxy.ctrlRef.validate();
        if (!valid) {
          isOK = valid;
        }
      }

      return isOK;
    };
  }

  return { validate: create() };
}

export function useFormItemValidate(formItemKeys: string[]) {
  const showParams = inject<ShowFormParameters>("showParams")!;
  function create() {
    return async () => {
      let isOK = true;
      for (let index = 0; index < formItemKeys.length; index++) {
        const formItemKey = formItemKeys[index]!;
        const proxy = getProxy(showParams.pageId, formItemKey) as ControlProxy;
        if (!proxy) continue;
        const valid = await proxy.ctrlRef.validate();
        if (!valid) {
          isOK = valid;
        }
      }

      return isOK;
    };
  }

  return { validate: create() };
}
